import { cn } from '@repo/tailwind-config/tailwind.functions'
import { TailwindColorOrString, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { InformationIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { PropsWithChildren } from 'react'

type Props = {
  note?: string
  className?: string
  color?: TailwindColorOrString
}

const NoteBox = ({
  note,
  className,
  color = tailwindColors.primary.DEFAULT,
  children
}: PropsWithChildren<Props>) => {
  return (
    <div className={cn('bg-primary-light rounded flex gap-1 p-2 items-center', className)}>
      <InformationIcon fill={color} className="w-6 h-6" />
      {children}
      {note && (
        <Typography variant="small-semibold" color={color}>
          {note}
        </Typography>
      )}
    </div>
  )
}

export default NoteBox
